import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PieChart, List, TrendingUp, HelpCircle } from 'react-feather';

// App-wide bottom navigation: the three core views. Settings lives as a
// gear icon in the page header, not here.
const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    { path: '/', label: 'Budget', icon: PieChart },
    { path: '/transaktioner', label: 'Transaktioner', icon: List },
    { path: '/analys', label: 'Analys', icon: TrendingUp },
    { path: '/rad', label: 'Har jag råd', icon: HelpCircle },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-stretch justify-around max-w-md mx-auto">
        {items.map(item => {
          const active = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate({ pathname: item.path, search: location.search })}
              className={`flex-1 flex flex-col items-center gap-0.5 py-2.5 text-xs font-medium transition-colors ${
                active ? 'text-blue-600' : 'text-gray-500 hover:text-gray-800'
              }`}
            >
              <Icon size={20} />
              {item.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
